import { defaultObj } from './state'

export default {
  addStore (state, storeData) {
    if (storeData && storeData.storeInfo) {
      state.stores[storeData.storeInfo.lmsId] = storeData
    }
  },

  reset (state) {
    state = Object.assign(state, defaultObj)
  }
}
